<template>
  <div class="select_season inp_wrap">
    <p>Выберите сезон</p>
    <select v-model="selected">
      <option :value="null">Все сезоны</option>
      <option
        v-for="item in items"
        :key="'season-' + item.id"
        :value="item.id"
      >{{ item.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectSeason',
  props: {
    items: {
      type: Array,
      default: () => {}
    },
    selectSeason: {
      type: Number
    }
  },
  computed: {
    selected: {
      get () {
        return this.selectSeason
      },
      set (value) {
        this.$emit('update:selectSeason', value)
        this.$nextTick(() => {
          this.$emit('change-filter')
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
